<template>
  <div class="ModalUploading">
    <h4>Files are still being uploaded</h4>
    <p>
      Please wait until your file uploads are complete before moving to a
      different page.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ModalUploading'
}
</script>

<style scoped lang="scss">
.ModalUploading {
  padding: 1rem 2rem;
  h4 {
    margin-bottom: 2rem;
    color: $color-primary;
    font-weight: bold;
    font-size: 22px;
  }
}
</style>
